import {Component, ElementRef, forwardRef, Input, OnInit} from "@angular/core";
import {NG_VALUE_ACCESSOR } from "@angular/forms"

const zero: string = "0";
const doubleZero: string = "00";
const colanDoubleZero: string = ":00";
const one: string = "1";
const colan: string = ":";

@Component({
    selector: "rx-time",
    template: "<input type='text' maxlength='5' [class.ng-invalid]='isInValid' (blur)='onBlur($event.target.value)' (keydown)='onKeydown($event,$event.target.value)' (keypress)='onKeypress($event.target,$event,$event.target.value)' (keyup)='onKeyup($event,$event.target.value)' class='{{controlClass}}' [(ngModel)]='time' />",
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RxTimeComponent), multi: true },
    ],
})
export class RxTimeComponent implements OnInit {
    element: Element;
    timeOutId: number;
    isInValid: boolean = false;
    private timeValue: string;
    private propagateChange: any = () => { };

    constructor(elementRef: ElementRef) {
        this.element = elementRef.nativeElement as Element;
    }

    set time(value: string) {
        this.timeValue = value;
        this.propagateChange(this.timeValue);
        this.checkValid(true);
    }

    get time(): string {
        return this.timeValue
    }

    @Input() controlClass: string;

    ngOnInit(): void {
        this.checkValid(true);
    }

    private registerOnChange(fn) {
        this.propagateChange = fn;
        this.propagateChange(this.time);
    }

    private registerOnTouched() { }


    private writeValue(value: string) {
        if (value) {
            var splitText = value.split(":");
            if (splitText.length >= 2)
                this.time = "".concat(splitText[0], ":", splitText[1]);
        } else {
            this.time = value;
        }
    }

    checkValid(isValid: boolean) {
        if (isValid)
            this.timeOutId = window.setTimeout(() => {
                for (var i = 0; i < this.element.classList.length; i++) {
                    this.isInValid = this.element.classList[i] == "ng-invalid";
                    if (this.isInValid)
                        break;
                }
                window.clearTimeout(this.timeOutId);
                this.timeOutId = undefined;
            }, 500);
        else
            this.isInValid = isValid;
    }

    onKeydown(event: KeyboardEvent, value: string): boolean {
        return !(event.keyCode === 46);
    }

    onBlur(value: string) {
        if (value.length === 1) {
            this.time = "".concat(zero, value, colanDoubleZero);
        } else if (value.length === 2) {
            this.time = this.time.concat(colanDoubleZero);
        } else if (value.length === 3) {
            if (value.charAt(2) == colan)
                this.time = this.time.concat(doubleZero);
            else
                this.time = "".concat(this.time.charAt(0), this.time.charAt(1), colan, this.time.charAt(2), zero);
        } else if (value.length === 4) {
            if (value.charAt(2) == colan)
                this.time = this.time.concat(zero);
            else
                this.time = "".concat(this.time.charAt(0), this.time.charAt(1), colan, this.time.charAt(2), this.time.charAt(3));
        }
    }

    onKeypress(element: HTMLInputElement, event: KeyboardEvent, value: string): boolean {
        var keyValue = String.fromCharCode(event.keyCode);
        return (
            (value.length === 0 && parseInt(keyValue) < 3)
            ||
            (value.length === 1 && (((value === zero || value === one) && parseInt(keyValue) < 10) || (parseInt(keyValue) < 4)))
            ||
            (value.length === 3 && (parseInt(keyValue) < 6))
            ||
            (value.length === 4 && (parseInt(keyValue) < 10))
        )
    }

    onKeyup(event: KeyboardEvent, value: string) {
        if (value.length == 2) {
            if (parseInt(value) < 24) {
                this.time = this.time.concat(colan);
            }
        }
        if (value.length == 2 && event.keyCode == 8) {
            this.time = value.substr(0, 1);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@rx/forms/time/rx_time_control_component.ts